<template>
  <chart-report
      v-if="!settings.loading"
      :error="settings.tableData.error"
      :settings="settings.chartData"
      :partner="partner"
      @change-map="changeMap($event)"
  ></chart-report>

  <div v-else class="w-100">
    <v-progress-circular
        indeterminate
        color="primary"
    ></v-progress-circular>
  </div>
</template>

<script>
import ChartReport from "./chartReport";

export default {
    name: 'ChartReportWr',
    components: {
        ChartReport,
    },
    props: {
        settings: {
            type: Object,
            required: true
        },
        partner: {
            type: Object,
            required: false
        },
    },
    methods: {
        changeMap(event) {
            //remit event to parent
            this.$emit('change-map', event)
        }
    }
    
}
</script>
